import script from "./CustomEmojiPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomEmojiPicker.vue?vue&type=script&setup=true&lang=js"

import "./CustomEmojiPicker.vue?vue&type=style&index=0&id=269032e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-269032e1"]])

export default __exports__